import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';
import { ClientProfileService } from '@pg-app/client/services/client-profile.service';
import { AuthService } from '@pg-app/core/services/auth.service';
import { StoreProvider } from '@pg-app/core/services/storeProvider/store.provider';
import { environment } from '@pg-env/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'np-profile-switching',
  templateUrl: './profile-switching.component.html',
  styleUrls: ['./profile-switching.component.scss']
})
export class ProfileSwitchingComponent implements OnInit {
  profileSwitchingComponentForm: FormGroup;

  profiles = [];
  private readonly PROFILE_STORE_KEY: string = 'profiles';
  private readonly EXPIRED_TIME: number = 300;

  columns = [
    {
      title: 'Account Number',
      name: 'leadCode',
      width: '150px',
      class: 'text-center',
    },
    {
      title: 'Account Name',
      name: 'leadName',
      width: '300px',
      class: 'text-center',
    },
    {
      title: '',
      name: 'action',
      hiddenSort: true,
      hiddenFilter: true,
      width: '100px',
      class: 'text-center',
    }
  ];

  constructor(private fb: FormBuilder, private router: Router,
    private clientService: ClientProfileService,
    private authService: AuthService,
    private loginInfo: LoginInfoService,
    private toastr: ToastrService,
    private store: StoreProvider) {}

  get accountCtrl() {
    return this.profileSwitchingComponentForm.get('account') as FormControl;
  }
  ngOnInit() {
    this.profileSwitchingComponentForm = this.fb.group({
      account: ''
    });

    this.loadProfileInRefreshCase();

    if (!this.loginInfo.email || this.loginInfo.profiles.length < 1){
      this.router.navigate(['/auth/login']);
    }

    this.profiles = this.loginInfo.profiles;

    if (this.profiles.length == 1){
      this.changeAccount(this.profiles[0].leadId, this.profiles[0].leadName);
    } else {
      this.profiles.forEach(p => {
        p.leadCodeAndName = p.leadCode + ', ' + p.leadName;
        p.action = `<span class="btn-action"> Select </span>`;
      });
    }
  }

  loadProfileInRefreshCase() {
    const currentTime = new Date();
    if (this.loginInfo.email) {
      this.store.remove(this.PROFILE_STORE_KEY);
      this.store.set(this.PROFILE_STORE_KEY, {...this.loginInfo,
        storedTime: currentTime.toISOString()
      });
      return;
    }

    const data = this.store.get(this.PROFILE_STORE_KEY);
    if (!this.loginInfo.email && data) {
      const lastVisitTime = new Date(data.storedTime);
      const timeDifferenceInSeconds = Math.floor((currentTime.getTime() - lastVisitTime.getTime()) / 1000);
      if (timeDifferenceInSeconds > this.EXPIRED_TIME) {
        this.store.remove(this.PROFILE_STORE_KEY);
        this.router.navigate(['/auth/login']);
      }
      this.loginInfo = data;
    } 
  }

  selectProfile($event) {
    if ($event.column === 'action') {
      var leadId =  $event.row.leadId;
      var leadName = $event.row.leadName;
      if ($event.row.isAccepted == false) {
        this.toastr.error(
          `Please contact your Relationship Manager for an update on access to your account. You can contact them via email help@${environment.domain} or phone ${environment.phone}`
        );
        return;
      }
      this.changeAccount(leadId, leadName);
    }
  }

  changeAccount(leadId, leadName){
      var email = this.loginInfo.email;
      var clientId = environment.clientId;
      var data = {
        leadId: leadId,
        email: email,
        clientId: clientId,
      };

      this.clientService.changeSelectedAccount(data).subscribe(res => {
        this.store.remove(this.PROFILE_STORE_KEY);
        this.authService.updateAccessToken(res);      
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate(['client/dashboard']));
      });
  }
}
